import translate from 'core/translate'
import { cn } from 'ethcss'
import { colors, text as textStyles } from 'theme'
import { grid } from 'theme'
import styles from './displays__moveSettings.jcss'
import { Typography } from 'atoms/Typography'
import { Radio } from 'atoms/Radio'
import React, { useState } from 'react'
import Button from 'blocks.simple/button/button'
import { appActions } from 'blocks.app/app/app.state'
import store from 'core/store'
import { api } from 'core/api/ConnectionManager'

interface DisplayMoveSettingProps {
    data: any
}

const DisplaysMoveSettings = (p_: DisplayMoveSettingProps) => {
    const userDisplayMoveSettings = store.getState().user.data?.settings?.digitalSignage || {
        groupScheduleMode: 'askEveryTime',
        overwriteSettings: 'askEveryTime'
    }
    const [partialData, setPartialData] = useState({
        groupScheduleMode: userDisplayMoveSettings?.groupScheduleMode === 'askEveryTime' ? 'apply' : userDisplayMoveSettings?.groupScheduleMode,
        overwriteSettings: userDisplayMoveSettings?.overwriteSettings === 'askEveryTime' ? true : userDisplayMoveSettings?.overwriteSettings
    })

    const onCancel = () => {
        store.dispatch(appActions.closeMoveSettingsModal())
    }

    const onSave = () => {
        const payload: any = {
            id: p_.data.id,
            overwriteSettings: partialData.overwriteSettings,
            groupScheduleMode: partialData.groupScheduleMode
        }

        if (p_.data.isGroup) {
            payload.parentId = p_.data.parentId
            api.send('editGroup', payload).then(() => {
                store.dispatch(appActions.closeMoveSettingsModal())
            })
        } else {
            payload.groupId = p_.data.groupId
            api.send('editDisplay', payload).then(() => {
                store.dispatch(appActions.closeMoveSettingsModal())
            })
        }
    }

    return (
        <div className={styles.wrapper}>
            {!(p_.data.disableGroupScheduleMode !== undefined) && <div>
                <Typography
                    type="title"
                    className={cn(
                        textStyles.centerBlock,
                        textStyles.up,
                        textStyles['normalPlus']
                    )}
                >
                    {translate('scheduleForDevice')}
                </Typography>
                <Radio
                    className={cn(grid.mt_md)}
                    label={
                        <Typography type="title">
                            {translate('changeCurrentSchedule')}
                        </Typography>
                    }
                    selected={partialData.groupScheduleMode === 'apply'}
                    onClick={function () {
                        setPartialData({ 
                            ...partialData,
                            groupScheduleMode: 'apply' 
                        })
                    }}
                />
                <Radio
                    className={cn(grid.mt_mini)}
                    label={
                        <Typography type="title">
                            {translate('remainCurrentSchedule')}
                        </Typography>
                    }
                    selected={partialData.groupScheduleMode === 'ignore'}
                    onClick={function () {
                        setPartialData({
                            ...partialData,
                            groupScheduleMode: 'ignore' 
                        })
                    }}
                />
            </div>}
            {!(p_.data.disableOverwriteSettings !== undefined) && <div className={grid.mt_md}>
                <Typography
                    type="title"
                    className={cn(
                        textStyles.centerBlock,
                        textStyles.up,
                        textStyles['normalPlus']
                    )}
                >
                    {translate('groupAndDevicesSettingsOnMove')}
                </Typography>
                <Radio
                    className={cn(grid.mt_md)}
                    label={
                        <Typography type="title">
                            {translate('replaceWithParentSettings')}
                        </Typography>
                    }
                    selected={partialData.overwriteSettings === true}
                    onClick={function () {
                        setPartialData({ 
                            ...partialData, 
                            overwriteSettings: true 
                        })
                    }}
                />
                <Radio
                    className={cn(grid.mt_mini)}
                    label={
                        <Typography type="title">
                            {translate('keepCurrentSettings')}
                        </Typography>
                    }
                    selected={partialData.overwriteSettings === false}
                    onClick={function () {
                        setPartialData({ 
                            ...partialData, 
                            overwriteSettings: false 
                        })
                    }}
                />
            </div>}
            <div className={styles.buttons}>
                <Button
                    rounded="full_md"
                    indentSize="mini"
                    onClick={onCancel}
                    className={cn(grid.mr_md)}
                >
                    {translate('cancel')}
                </Button>
                <Button 
                    rounded="full_md" 
                    indentSize="mini" 
                    mod="fill" 
                    onClick={onSave}>
                    {translate('save')}
                </Button>
            </div>
        </div>
    )
}


export default DisplaysMoveSettings;